import { render, staticRenderFns } from "./Threads.vue?vue&type=template&id=a49df56e&scoped=true"
import script from "./Threads.vue?vue&type=script&lang=js"
export * from "./Threads.vue?vue&type=script&lang=js"
import style0 from "./Threads.vue?vue&type=style&index=0&id=a49df56e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49df56e",
  null
  
)

export default component.exports